import type { MouseEvent } from 'react';
import { InlineButton } from '@picsart/design-system/components/InlineButton';
import { IconLikeFilled } from '@picsart/design-system/foundation/icons/IconLikeFilled';
import { IconLikeOutline } from '@picsart/design-system/foundation/icons/IconLikeOutline';
import { IconDislikeFilled } from '@picsart/design-system/foundation/icons/IconDislikeFilled';
import { IconDislikeOutline } from '@picsart/design-system/foundation/icons/IconDislikeOutline';
import { UserReactions } from '@/types';
import type { UserReaction } from '@/types';
import type { ReactionButtonsProps } from './types';

const ReactionButtons = ({
  reaction,
  onReact,
  size,
  className,
  isWithoutBorder,
  dataTestIdPrefix,
}: ReactionButtonsProps) => {
  const handleReact = (value: UserReaction) => (e: MouseEvent) => {
    e.stopPropagation();
    onReact(value);
  };

  return (
    <>
      <InlineButton
        size={size}
        centerIcon={
          reaction === UserReactions.Like ? IconLikeFilled : IconLikeOutline
        }
        onClick={handleReact(UserReactions.Like)}
        aria-label="Like"
        className={className}
        dataTestId={`${dataTestIdPrefix}-like`}
        isWithoutBorder={isWithoutBorder}
      />
      <InlineButton
        size={size}
        centerIcon={
          reaction === UserReactions.Dislike
            ? IconDislikeFilled
            : IconDislikeOutline
        }
        onClick={handleReact(UserReactions.Dislike)}
        aria-label="Dislike"
        className={className}
        dataTestId={`${dataTestIdPrefix}-dislike`}
        isWithoutBorder={isWithoutBorder}
      />
    </>
  );
};

export default ReactionButtons;
